// @ts-nocheck THIS IS A GENERATED FILE, DO NOT EDIT
import * as PrivateSchemaTypes from '../../../graphql/private/PrivateSchemaTypes';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
import * as ApolloReactHooks from '@apolloHooksWithThrowingQuery';
const defaultOptions =  {}
export type SearchQueryVariables = PrivateSchemaTypes.Exact<{
  query: PrivateSchemaTypes.Scalars['LengthValidatedString_255'];
  sort?: PrivateSchemaTypes.Maybe<PrivateSchemaTypes.SearchSortEnum>;
  limit?: PrivateSchemaTypes.Maybe<PrivateSchemaTypes.Scalars['PositiveInt']>;
}>;


export type SearchQuery = (
  { __typename?: 'Query' }
  & { search: Array<(
    { __typename?: 'TopicModelAsMember' }
    & Pick<PrivateSchemaTypes.TopicModelAsMember, 'id'>
    & { currentTopicVersion?: PrivateSchemaTypes.Maybe<(
      { __typename?: 'TopicVersionModel' }
      & Pick<PrivateSchemaTypes.TopicVersionModel, 'id' | 'title' | 'summary' | 'readDurationMins'>
    )>, lastEnrolment?: PrivateSchemaTypes.Maybe<(
      { __typename?: 'TopicEnrolmentModelAsStudent' }
      & Pick<PrivateSchemaTypes.TopicEnrolmentModelAsStudent, 'id' | 'target_completion_date' | 'share_batch_ts' | 'status' | 'progress'>
    )>, author: (
      { __typename?: 'UserModelPublicBase' }
      & Pick<PrivateSchemaTypes.UserModelPublicBase, 'id' | 'display_name'>
    ), coverImage?: PrivateSchemaTypes.Maybe<(
      { __typename?: 'DocumentModel' }
      & Pick<PrivateSchemaTypes.DocumentModel, 'id' | 'cdnUrl'>
    )>, coverImageVariants: Array<(
      { __typename?: 'ImageVariantModel' }
      & Pick<PrivateSchemaTypes.ImageVariantModel, 'document_id' | 'cdnUrl'>
    )> }
  ) | (
    { __typename?: 'WorkspaceModelAsMember' }
    & Pick<PrivateSchemaTypes.WorkspaceModelAsMember, 'id' | 'name' | 'publishedTopicsCount'>
    & { coverImage?: PrivateSchemaTypes.Maybe<(
      { __typename?: 'DocumentModel' }
      & Pick<PrivateSchemaTypes.DocumentModel, 'id' | 'cdnUrl'>
      & { imageVariants: Array<(
        { __typename?: 'ImageVariantModel' }
        & Pick<PrivateSchemaTypes.ImageVariantModel, 'size_key' | 'cdnUrl'>
      )> }
    )> }
  ) | (
    { __typename?: 'PathwayModelAsStudent' }
    & Pick<PrivateSchemaTypes.PathwayModelAsStudent, 'id' | 'title' | 'currentTopicVersionsCount'>
    & { coverImage?: PrivateSchemaTypes.Maybe<(
      { __typename?: 'DocumentModel' }
      & Pick<PrivateSchemaTypes.DocumentModel, 'id' | 'cdnUrl'>
    )>, coverImageVariants: Array<(
      { __typename?: 'ImageVariantModel' }
      & Pick<PrivateSchemaTypes.ImageVariantModel, 'cdnUrl' | 'size_key'>
    )>, tags: Array<(
      { __typename?: 'TagModel' }
      & Pick<PrivateSchemaTypes.TagModel, 'id' | 'name'>
    )>, currentEnrolment?: PrivateSchemaTypes.Maybe<(
      { __typename?: 'PathwayEnrolmentModelAsStudent' }
      & Pick<PrivateSchemaTypes.PathwayEnrolmentModelAsStudent, 'id' | 'completed_at' | 'target_date' | 'progress' | 'status'>
    )> }
  ) | (
    { __typename?: 'EventModelAsStudent' }
    & Pick<PrivateSchemaTypes.EventModelAsStudent, 'id' | 'allow_comments' | 'created_at' | 'description' | 'end_time' | 'attendeesCount' | 'is_open' | 'location' | 'organisation_id' | 'participants_limit' | 'published_date' | 'start_time' | 'timezone'>
    & { eventTitle: PrivateSchemaTypes.EventModelAsStudent['title'] }
    & { tags: Array<(
      { __typename?: 'TagModel' }
      & Pick<PrivateSchemaTypes.TagModel, 'id' | 'name'>
    )> }
  ) | { __typename?: 'SurveyModelAsStudent' } | { __typename?: 'CampaignModel' } | (
    { __typename?: 'CertificationModelAsStudent' }
    & Pick<PrivateSchemaTypes.CertificationModelAsStudent, 'id' | 'name'>
  )> }
);


export const SearchDocument = gql`
    query search($query: LengthValidatedString_255!, $sort: SearchSortEnum, $limit: PositiveInt) {
  search(query: $query, sort: $sort, limit: $limit) {
    ... on TopicModelAsMember {
      id
      currentTopicVersion {
        id
        title
        summary
        readDurationMins
      }
      lastEnrolment {
        id
        target_completion_date
        share_batch_ts
        status
        progress
      }
      author {
        id
        display_name
      }
      coverImage {
        id
        cdnUrl
      }
      coverImageVariants {
        document_id
        cdnUrl
      }
    }
    ... on WorkspaceModelAsMember {
      id
      name
      coverImage {
        id
        cdnUrl
        imageVariants {
          size_key
          cdnUrl
        }
      }
      publishedTopicsCount
    }
    ... on PathwayModelAsStudent {
      id
      title
      currentTopicVersionsCount
      coverImage {
        id
        cdnUrl
      }
      coverImageVariants {
        cdnUrl
        size_key
      }
      tags {
        id
        name
      }
      currentEnrolment {
        id
        completed_at
        target_date
        progress
        status
      }
    }
    ... on EventModelAsStudent {
      id
      allow_comments
      created_at
      description
      end_time
      attendeesCount
      is_open
      location
      organisation_id
      participants_limit
      published_date
      start_time
      timezone
      eventTitle: title
      tags {
        id
        name
      }
    }
    ... on CertificationModelAsStudent {
      id
      name
    }
  }
}
    `;

/**
 * __useSearchQuery__
 *
 * To run a query within a React component, call `useSearchQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchQuery({
 *   variables: {
 *      query: // value for 'query'
 *      sort: // value for 'sort'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useSearchQuery(baseOptions: ApolloReactHooks.QueryHookOptions<SearchQuery, SearchQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<SearchQuery, SearchQueryVariables>(SearchDocument, options);
      }
export function useSearchLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<SearchQuery, SearchQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<SearchQuery, SearchQueryVariables>(SearchDocument, options);
        }
export type SearchQueryHookResult = ReturnType<typeof useSearchQuery>;
export type SearchLazyQueryHookResult = ReturnType<typeof useSearchLazyQuery>;
export type SearchQueryResult = Apollo.QueryResult<SearchQuery, SearchQueryVariables>;